import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import classNames from 'classnames';
import { Link } from 'gatsby';

import { Title } from 'components/typography';
import CircularArrow from 'components/circularArrow';

import {
  descriptionContainer,
  solutionCard,
  iconLinkContainer,
  iconContainer,
  titleContainer,
  solutionPageLink,
} from './scss/SolutionCard.module.scss';

const SolutionCard = ({ solution }) => (
  <div className={classNames(solutionCard, solution.id)}>
    <div className={'solution'}>
      <Link to={solution.url} className={solutionPageLink}>
        <div className={titleContainer}>
          <div>
            {solution.icon && (
              <div className={classNames(iconContainer, 'solutionIcon')}>
                <solution.icon />
              </div>
            )}
            {solution.title.map(title => (
              <div key={shortid()} className="solutionTitle">
                <Title value={title} />
              </div>
            ))}
          </div>
        </div>

        <div className={descriptionContainer}>
          <p>{solution.description}</p>
        </div>

        {solution.icon && (
          <div className={classNames(iconLinkContainer, 'd-none d-lg-block')}>
            <CircularArrow />
          </div>
        )}
      </Link>
    </div>
  </div>
);

SolutionCard.propTypes = {
  solution: PropTypes.shape({}).isRequired,
};

export default SolutionCard;
